import { useSearchParams } from 'react-router-dom';
import { authApi } from '@/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function LoginPage() {
  const [params] = useSearchParams();
  const error = params.get('error');

  return (
    <div className="mx-auto max-w-md p-12">
      <Card>
        <CardContent className="pt-8 text-center">
          <h1 className="text-2xl font-extrabold text-eol-white">Вход</h1>
          <p className="mt-2 text-eol-desc">
            Авторизация на сайте - только через Discord.
          </p>
          {error && (
            <p className="mt-4 text-sm text-eol-red">
              Ошибка авторизации: {error}
            </p>
          )}
          <Button asChild className="mt-6 w-full">
            <a href={authApi.loginUrl()}>Войти через Discord</a>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
